import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '../modules/components/Section';
import Eyebrow from '../modules/components/Eyebrow';

/** 理念。写真とテキストの2カラム（トップのコンセプトと同型）。 */
function Philosophy() {
  return (
    <Section bg="paper" py={0} sx={{ pt: { xs: 8, sm: 12 }, pb: { xs: 10, sm: 15 } }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: { xs: 5, sm: 11 },
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            aspectRatio: '4 / 3',
            backgroundImage: 'url(/images/kaisha.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            bgcolor: 'kinari',
          }}
        />
        <Box>
          <Eyebrow>Philosophy</Eyebrow>
          <Typography
            variant="h2"
            component="h2"
            sx={{ fontSize: { xs: 24, sm: 30 }, letterSpacing: '.1em', lineHeight: 1.6, mb: 3.5 }}
          >
            地域とともに「つくる」
          </Typography>
          <Typography sx={{ fontSize: 15.5, color: 'text.secondary' }}>
            創業以来、地域に根差した工務店として歩んできました。地域に根差すことで生まれる安心感と信頼感は、お客様の幸せな暮らしを支える基本であり、快適な空間づくりを支える基礎となります。飯田建築は長年の技術と提案力で、お客様の理想や思い描く空間をともにつくります。
          </Typography>
        </Box>
      </Box>
    </Section>
  );
}

export default Philosophy;
